// extracted by mini-css-extract-plugin
export default {"response":"FeedbackResponseBanner-module__response___3fpZi"};